import Link, { LinkProps } from '@material-ui/core/Link';
import { makeStyles } from '@material-ui/core/styles';
import withThemeProps from '@sprinx/react-mui-components/withThemeProps';
import clsx from 'clsx';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

export interface ProductDetailLinkProps extends Omit<LinkProps<RouterLink>, 'classes'> {
  children: NonNullable<React.ReactNode>;
  classes?: Partial<Record<ProductDetailLinkClassKey, string>>;
  preserveScroll?: boolean;
}

export type ProductDetailLinkClassKey = 'root';

const themeSettings = { name: 'ProductDetailLink' };
const useStyles = makeStyles(
  (/* theme */) => ({
    root: {
      textDecoration: 'none',
      '&:hover': {
        textDecoration: 'none',
      },
    },
  }),
  themeSettings,
);

const ProductDetailLink = React.forwardRef<HTMLAnchorElement, ProductDetailLinkProps>(
  ({ children, className, classes: pClasses, to, preserveScroll, onClick, ...rest }, ref) => {
    const classes = useStyles({ classes: pClasses });

    const handleClick = React.useCallback(
      (event: React.MouseEvent<HTMLAnchorElement>) => {
        if (preserveScroll) {
          sessionStorage.setItem('catalogueScrollY', String(window.scrollY));
        }

        onClick?.(event);
      },
      [preserveScroll, onClick],
    );

    return (
      <Link
        ref={ref}
        className={clsx(classes.root, className)}
        component={RouterLink}
        to={to}
        {...rest}
        onClick={preserveScroll || onClick ? handleClick : undefined}
      >
        {children}
      </Link>
    );
  },
);

ProductDetailLink.displayName = 'ProductDetailLink';

export default withThemeProps(themeSettings)(ProductDetailLink);
